import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { getClaimReasons } from '~/utils/claimLineItem';
import { ClaimReasonCategoryCode } from '~/utils/constants';
import {
  makeDraftClaimLineItemAction,
  makeDraftClaimLineItemLoader,
  redirect,
} from '~/utils/routing';

export const { loader, useLoaderData } = makeDraftClaimLineItemLoader(
  ({
    context: {
      draftClaimLineItem,
      crewClaim: { claimType },
    },
  }) => ({
    draftClaimLineItem,
    reasons: getClaimReasons(claimType, draftClaimLineItem).map(
      ({ id, name }) => ({
        name,
        id,
      }),
    ),
  }),
);

export const INPUT_NAME = 'reasonId';

const formSchema = zfd.formData({
  [INPUT_NAME]: zfd.numeric(
    z
      .number({ message: 'Please choose a reason.' })
      .int({ message: 'Invalid reason ID.' })
      .positive({ message: 'Invalid reason ID.' }),
  ),
});

export const { action, useActionResult } = makeDraftClaimLineItemAction(
  ({ formData, context }, appStore) => {
    const {
      order,
      draftClaimLineItem,
      crewClaim: { claimType },
    } = context;
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: result.error.message,
      };
    }

    const { reasonId } = result.data;

    const reason = getClaimReasons(claimType, draftClaimLineItem).find(
      ({ id }) => id === reasonId,
    );

    if (!reason) {
      return {
        ok: false,
        message: 'Invalid claim reason.',
      };
    }

    appStore.dispatch(
      appStore.actions.draftClaimLineItem.setReason({
        reasonId,
        reasonCategoryCode: reason.category.code,
      }),
    );

    const hasShippingProtection =
      !!order?.wasShippingProtected &&
      reason.category.code === ClaimReasonCategoryCode.shippingIssue;

    return hasShippingProtection ?
        redirect('../shipping-protection')
      : redirect(`${reasonId}`);
  },
);
